import { Contrast, argbFromHex, hexFromArgb, Hct, } from "@material/material-color-utilities";
const paletteIncrementMap = {
    100: 6,
    200: 5,
    300: 4,
    400: 3,
    500: 2,
    600: 1,
    700: 0,
    800: -1,
    900: -2,
};
const getPaletteColor = (baseHct, index) => {
    const baseHue = baseHct.hue;
    const baseChroma = baseHct.chroma;
    const baseTone = baseHct.tone;
    const toneIncrement = (100 - baseTone) / 7;
    const chromaIncrement = baseChroma / 7;
    return hexFromArgb(Hct.from(baseHue, baseChroma -
        chromaIncrement *
            (paletteIncrementMap[index] > 0 ? paletteIncrementMap[index] : 0), baseTone + toneIncrement * paletteIncrementMap[index]).toInt());
};
export function getPalette(color) {
    const argb = argbFromHex(color);
    const baseHCT = Hct.fromInt(argb);
    return {
        100: getPaletteColor(baseHCT, 100),
        200: getPaletteColor(baseHCT, 200),
        300: getPaletteColor(baseHCT, 300),
        400: getPaletteColor(baseHCT, 400),
        500: getPaletteColor(baseHCT, 500),
        600: getPaletteColor(baseHCT, 600),
        700: getPaletteColor(baseHCT, 700),
        800: getPaletteColor(baseHCT, 800),
        900: getPaletteColor(baseHCT, 900),
    };
}
export function getInverseTextColor(color) {
    const argb = argbFromHex(color);
    const hct = Hct.fromInt(argb);
    const ratio = Contrast.ratioOfTones(hct.tone, 100);
    if (ratio < 4.5) {
        return "#000000";
    }
    return "#ffffff";
}
export function getTextColor(color) {
    const argb = argbFromHex(color);
    const hct = Hct.fromInt(argb);
    const ratio = Contrast.ratioOfTones(hct.tone, 100);
    if (ratio < 4.5) {
        return hexFromArgb(Hct.from(hct.hue, hct.chroma, 30).toInt());
    }
    return color;
}
//# sourceMappingURL=themeColors.js.map